var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-title',[_vm._v(" 裸金属边缘签发器 ")]),_c('v-card-subtitle',[_vm._v(" 提供最基本的边缘网关Token签发功能 ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }